import { Box, Button } from '@mui/material';
import React, { useContext, useState } from 'react'
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';

const steps = [
    {
        target: '.approver-tour-1',  
        title: 'Publication Tab',
        content: 'Click a button to filter publications by type.',
        placement: 'bottom',
        disableBeacon: true,
        disableScrollParentFix: true,
        disableScrolling: true,
    },
    {
        target: '.approver-tour-2',
        title: 'View',
        content: 'Click the view icon to open this publication.',
        placement: 'top',
        disableBeacon: true,
    },
    
];

export const Approver = () => {
    const { tool_state, personalization_state } = useContext(ToolContext);
    const { __SESSION } = tool_state;
    const { walkthrough } = personalization_state

    const [stepIndex, setStepIndex] = useState(0);

    const user_id = window.atob(__SESSION.data.ainfo.aid).slice(8);
    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const handleJoyrideCallback = async (data) => {
        const { status, action, index, type } = data;        

        let body = {
            user_id: user_id,
            tool_id: tool_id,
            feature_name: 'approver',
            personalization:[{sf_name: 'approver', status: 1}]
        }

        if (type === 'step:after' && action === 'next') {    
            setStepIndex(index + 1);
        }
        
        if (['close', 'stop'].includes(action)) {
            walkthrough.set(prev => ({...prev, approver: false}))
            setStepIndex(0);
            await rqx.post(`<<global>>/${env()}/personalization/create`, body)
        }
    };	
        
    return (
        <Joyride
            run={walkthrough.data.approver}
            continuous
            disableOverlayClose={true}
            steps={steps}
            stepIndex={stepIndex}
            showSkipButton={true}
            callback={handleJoyrideCallback}
            tooltipComponent={CustomComponent}
        />
    )
}

export const CustomComponent = ({ step, index, totalSteps, primaryProps, closeProps, tooltipProps }) => {
    return (
        <Box {...tooltipProps} width="340px" p={2} bgcolor="#fff" borderRadius="8px">
            <Box fontSize="14px" fontWeight="600">{step.title}</Box>
            <Box fontSize="12px" py="4px">{step.content}</Box>

            <Box width="100%" display="flex" justifyContent="flex-end"  gap="4px">
                <Button {...closeProps} variant={index === 1 ? 'contained' : 'Skip'} disableElevation sx={{ fontSize: '12px', p: '4px 16px' }}>
                    {index === 1 ? 'Got it!' : 'Skip'}
                </Button>
                {
                    index !== 1 &&
                    <Button {...primaryProps} variant="contained" disableElevation sx={{fontSize: '12px', p: '4px 16px'}}>
                        Next
                    </Button>
                }
            </Box>
        </Box>
    );
};
